<template>
	<div class="container">
		<div class="mian" v-watermark>
			<div class="main-header">
				<page-header :title="title"></page-header>
				<van-button type="primary" color="#ee2528" @click="onInquiryClose"
					:disabled="!(data.status == 0 || data.status == 1)">替患者主动结束当前问诊</van-button>
			</div>

			<div class="content">
				<div class="rows" style="display: flex; justify-content: space-between">
					<div class="row">
						<div class="row-label">患病信息</div>
						<div class="row-value">
							{{ data.name }} {{ data.sex | sexFilter }} {{ data.age }}岁
						</div>
					</div>
					<div class="row" style="flex: none; margin-left: 30px; text-align: right"
						v-if="!(data.status == 0 || data.status == 1) && data.endAskReason">
						<div class="row-label">结束原因</div>
						<div class="row-value">{{ data.endAskReason }}</div>
					</div>
				</div>
				<!-- <div class="row">
                    <div class="row-label">是否到线下医院就诊过</div>
                    <div class="row-value">{{offlineVisit(data.isHospitalVisit)}}</div>
                </div> -->
				<div class="row">
					<div class="row-label">首诊信息</div>
					<div class="row-value">
						<div class="p">
							<span class="p-label">首诊医院：</span>
							<span>{{ data.hospitalName || '-' }}</span>
						</div>
						<div class="p">
							<span class="p-label">首诊诊断：</span>
							<span>{{ data.hospitalDiagnose || '-' }}</span>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="row-label">本次问诊病种</div>
					<!-- <div class="row-value">{{data.askType | serviceItemFilter(data.askType)}}</div> -->
					<!-- <div class="row-value">{{data.diseaseTypeStarName}}</div> -->
					<div class="row-value">
						<template v-if="data.subDiseaseTypes">
							<span v-for="(itm, idx) in data.subDiseaseTypes.split(',')" :key="idx">
								<span>{{ idx > 0 ? "、" : "" }}</span>
								<span :style="data.diseaseType === (itm | 0) ? 'color: #4187f7' : ''">{{
					getDiseaseTypeName(itm | 0) }}</span>
							</span>
						</template>
						<span v-else>{{ getDiseaseTypeName(data.diseaseType) || '病种待确认' }}</span>
					</div>
				</div>
				<div class="row">
					<div class="row-label">本次问诊主诉症状</div>
					<div class="row-value">
						<template v-if="data.askDiseaseList?.length">
							<span v-for="(itm, idx) in data.askDiseaseList" :key="idx">
								<span>{{ idx > 0 ? "、" : "" }}</span>
								<span>{{ itm.name }}</span>
							</span>
						</template>
						<span v-else>症状待确认</span>
					</div>
				</div>
				<!-- <div class="row">
                    <div class="row-label">患病多久</div>
                    <div class="row-value">{{ data.askIllnessYears }}</div>
                </div> -->
				<!-- <div class="row">
                    <div class="row-label">就诊的医院</div>
                    <div class="row-value">{{ data.hospitalName }}</div>
                </div> -->
				<!-- <div class="row">
                    <div class="row-label">上次医院就诊结果</div>
                    <div class="row-value">{{ data.icdName || data.diagnose || '暂无' }}</div>
                </div> -->
				<div class="row" v-if="data.takeMedicineFeel">
					<div class="row-label">服药感受</div>
					<div class="row-value">{{ data.takeMedicineFeel }}</div>
				</div>
				<div class="row">
					<div class="row-label">病情描述</div>
					<div class="row-value">{{ data.illness }}</div>
				</div>
				<div class="row">
					<div class="row-label">三因反馈</div>
					<div class="row-item">
						<div class="item-lable">隆：</div>
						<div class="item-info">{{ feedback.info1 || '无' }}</div>
					</div>
					<div class="row-item">
						<div class="item-lable">赤巴：</div>
						<div class="item-info">{{ feedback.info2 || '无' }}</div>
					</div>
					<div class="row-item">
						<div class="item-lable">培根：</div>
						<div class="item-info">{{ feedback.info3 || '无' }}</div>
					</div>
				</div>
				<div class="row" v-if="data.images">
					<div class="row-label">相关的病情图片</div>
					<div class="row-value" style="margin-left: -3px; margin-top: -3px">
						<!-- <van-image
                            fit="cover"
                            :src="item"
                            v-for="(item, index) in data.images.split(',')"
                            :key="index"
                            @click="prevImg2(index, data.images.split(','))" v-show="item" style="margin: 3px;" /> -->
						<TwiceUploads :fileList="(data.images || '').split(',').map((item) => ({ url: item }))"
							:isShowEdit="false" />
					</div>
				</div>
				<div class="row" v-if="data.threeConditionImages">
					<div class="row-label">左眼眼睑+右眼眼睑+舌苔+舌下脉络图片</div>
					<div class="row-value">
						<div class="flex">
							<div class="img" v-for="(item, index) in threeImagesImport(data.threeConditionImages)"
								:key="index">
								<van-image fit="cover" :src="item"
									@click="prevImg2(index, threeImagesImport(data.threeConditionImages))">
									<template v-slot:error>暂无图片</template>
								</van-image>
							</div>
						</div>
					</div>
				</div>
				<template v-if="data.orderStatus == 1">
					<div class="row">
						<div class="row-label">药品金额</div>
						<div class="row-value">￥{{ data.totalFee || '0.00' }}</div>
					</div>
					<div class="row" v-if="data.shippingFee">
						<div class="row-label">运费</div>
						<div class="row-value">￥{{ data.shippingFee || '0.00' }}</div>
					</div>
					<div class="row">
						<div class="row-label">优惠金额</div>
						<div class="row-value">-￥{{ data.discount || '0.00' }}</div>
					</div>
					<div class="row">
						<div class="row-label">实付金额</div>
						<div class="row-value">￥{{ data.payAmount || '0.00' }}</div>
					</div>
				</template>
				<div class="row">
					<div class="row-label">
						<div class="row-label-box">
							<span>收货地址</span>
							<div class="edit" @click="onAddressEditShow"
								v-if="(data.orderItemStatus === null || data.orderItemStatus === 4 || data.orderItemStatus === 13) && !(data.status == 2 && (data.isPrescription != 1 || (data.isPrescription == 1 && data.orderStatus == 3))) && data.changeDeliverType">
								<van-icon name="edit" />
								<span>修改</span>
							</div>
						</div>
					</div>
					<div class="row-value">
						<div class="row-address">
							<template v-if="data.deliverType == 2">
								<div class="txt">用户自取</div>
							</template>
							<template v-else-if="data.userDeliveryAddress && data.userDeliveryAddress.address">
								<div class="txt">
									{{ data.userDeliveryAddress.name }}，{{
					data.userDeliveryAddress.phone
				}}，{{
						data.userDeliveryAddress.province
					}}{{
						data.userDeliveryAddress.city
					}}{{
						data.userDeliveryAddress.area
					}}{{ data.userDeliveryAddress.address }}
								</div>
								<CoCopy :content="'收货地址：' +
					data.userDeliveryAddress.name +
					'，' +
					data.userDeliveryAddress.phone +
					'，' +
					data.userDeliveryAddress.province +
					data.userDeliveryAddress.city +
					data.userDeliveryAddress.area +
					data.userDeliveryAddress.address
					" />
							</template>
							<template v-else>
								<div class="none">暂未填写</div>
							</template>
						</div>
					</div>
				</div>
				<div class="row">
					<Remarks :ask-no="askNo" />
				</div>
				<div class="attach">
					<div class="label">
						<div class="name">诊疗附件：</div>
						<div class="file" v-if="data.treatmentAttach" @click="onAttachFileDownload(data.treatmentAttach)">
							<span>{{ attachFileNameComputed }}</span>
						</div>
					</div>
					<div class="value">
						<van-button color="#e9f3ff" size="small"
							@click="$refs.UploadAttachRef && $refs.UploadAttachRef.init()">
							{{data.treatmentAttach ? '重新上传' : '上传附件'}}
						</van-button>
					</div>
				</div>
			</div>
		</div>

		<div class="buttons">
			<div class="buttons-box">
				<!-- <div class="item"
					@click="$router.push('/inquiryInfo/record?askNo=' + askNo + '&userNo=' + data.userNo)">
					<div class="item-box">
						<div class="icon record">
							<div class="icon-box"></div>
						</div>
						<div class="name">查看病历</div>
					</div>
				</div> -->
				<div class="item" :class="{ dis: data.isPrescription != 1 }" @click="getPrescriptions">
					<div class="item-box">
						<div class="icon prescription">
							<div class="icon-box"></div>
						</div>
						<div class="name">查看处方</div>
					</div>
				</div>
				<div class="item" @click="$router.push('/inquiryInfo/edit?askNo=' + askNo)">
					<div class="item-box">
						<div class="icon edit">
							<div class="icon-box"></div>
						</div>
						<div class="name">修改问诊</div>
					</div>
				</div>
				<div class="item" @click="$router.push('/inquiryInfo/logistics?askNo=' + askNo)">
					<div class="item-box">
						<div class="icon logistics">
							<div class="icon-box"></div>
						</div>
						<div class="name">查看物流</div>
					</div>
				</div>
				<!-- <div class="item" v-if="data.isPrescription" @click="$router.push(`/order/advice?askNo=${askNo}`)">
					<div class="item-box">
						<div class="icon evaluate">
							<van-icon name="todo-list" color="#00a103" />
						</div>
						<div class="name">用药指导</div>
					</div>
				</div> -->
				<div class="item" @click="$router.push(`/chat?askNo=${askNo}`)">
					<div class="item-box">
						<div class="icon message">
							<svg t="1715138840241" class="icon" viewBox="0 0 1025 1024" version="1.1"
								xmlns="http://www.w3.org/2000/svg" p-id="6961" width="64" height="64">
								<path
									d="M512.300999 22.875955c-282.939447 0-511.699001 200.465608-511.699001 447.285126 0 12.641975 0.601999 25.283951 1.805996 37.925926 12.039976 125.817754 83.677837 236.585538 190.231628 311.233392L192.639624 987.278072c0 25.885949 28.293945 41.537919 49.965902 28.293945l173.97766-105.349794c31.303939 4.815991 63.209877 7.825985 95.717813 7.825985 267.889477 0 487.619048-179.997648 509.893004-409.3592 1.203998-12.641975 2.407995-25.283951 2.407995-37.925926C1024 223.341564 794.638448 22.875955 512.300999 22.875955zM255.8495 450.897119c0-17.457966 14.447972-31.905938 31.905938-31.905938l46.955908 0c17.457966 0 31.905938 14.447972 31.905938 31.905938 0 17.457966-14.447972 31.905938-31.905938 31.905938l-46.955908 0C270.297472 483.405056 255.8495 468.957084 255.8495 450.897119zM671.830688 630.292769 352.169312 630.292769c-17.457966 0-31.905938-14.447972-31.905938-31.905938 0-17.457966 14.447972-31.905938 31.905938-31.905938l320.263374 0c17.457966 0 31.905938 14.447972 31.905938 31.905938C703.736626 615.844797 689.890653 630.292769 671.830688 630.292769zM736.244562 483.405056 455.71311 483.405056c-17.457966 0-31.905938-14.447972-31.905938-31.905938 0-17.457966 14.447972-31.905938 31.905938-31.905938l279.929453 0c17.457966 0 31.905938 14.447972 31.905938 31.905938C768.1505 468.957084 753.702528 483.405056 736.244562 483.405056z"
									p-id="6962" fill="#B655F3"></path>
							</svg>
						</div>
						<div class="name">沟通记录</div>
					</div>
				</div>
				<!-- <div class="item" @click="$router.push('/evaluate?askNo=' + askNo)" v-if="data.isAskEvaluate">
					<div class="item-box">
						<div class="icon evaluate">
							<van-icon name="todo-list" color="#00a103"/>
						</div>
						<div class="name">满意度调查</div>
					</div>
				</div> -->
			</div>
		</div>

		<prev-page :text="'返回问诊记录'" @back="back"></prev-page>
		<!-- 三因问诊反馈 -->
		<van-overlay z-index="10" :show="showThreeCause" @click="showThreeCause = false" :lock-scroll="false">
			<div class="wrapper">
				<div class="block" @click.stop>
					<div class="item" v-for="(item, index) in questionAllList" :key="index">
						<div class="header" v-if="index == 0">隆失调的表现</div>
						<div class="header" v-else-if="index == 1">赤巴失调的表现</div>
						<div class="header" v-else-if="index == 2">培根失调的表现</div>
						<div class="row" v-for="(items, idx) in item" :key="idx">
							<span>{{ items.questionNo }}. {{ items.questionSubject }}</span>
							<span :class="{ questionRadio: items.questionRadio == 1 }">{{
					items.questionRadio == 1 ? "是" : "否"
				}}</span>
						</div>
					</div>
				</div>
			</div>
		</van-overlay>
		<!-- 聊天记录 -->
		<van-overlay :show="showChat" @click="showChat = false">
			<div class="wrapper">
				<div class="chat" @click.stop>
					<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
						<div class="content" v-for="(item, index) in chatList" :key="index">
							<div v-if="item.direction == 0 && item.messageType == 5" class="left-box">
								<div class="sendTime">{{ item.sendTime }}</div>
								<div class="left-info">
									<div class="avatar">
										<img :src="data.userImage" />
									</div>
									<div class="message-box">
										<div class="sendName">{{ item.sendName }}</div>
										<div class="message">
											<p>
												{{ item.sendName }}（{{
					data.sex | sexFilter
				}}&nbsp;,&nbsp;{{ item.payload.age }}）
											</p>
											<!-- <p v-if="item.payload.isOfflineVisit!=null && item.payload.isOfflineVisit!=''">是否到线下医院就诊过：{{item.payload.isOfflineVisit == '1'?'是':'否'}}</p> -->
											<p
												v-if="item.payload.isHospitalVisit != null && item.payload.isHospitalVisit != ''">
												是否到线下医院就诊过：{{
					offlineVisit(item.payload.isHospitalVisit)
				}}
											</p>
											<p
												v-if="item.payload.diseaseType != null && item.payload.diseaseType != ''">
												本次问诊病种:{{
					item.payload.diseaseType
					| serviceItemFilter(item.payload.diseaseType)
				}}
											</p>
											<p
												v-if="item.payload.askIllnessYears != null && item.payload.askIllnessYears != ''">
												患病多久：{{ item.payload.askIllnessYears }}
											</p>
											<p v-if="item.hospitalName != null && item.hospitalName != ''">
												就诊的医院：{{ item.hospitalName }}
											</p>
											<!-- <p v-if="item.payload.icdName != null && item.payload.icdName != ''">上次医院就诊结果：{{ item.payload.icdName }}</p> -->
											<p v-if="item.payload.illness != null && item.payload.illness != ''">
												病情描述：{{ item.payload.illness }}
											</p>
											<div v-if="item.payload.image != null && item.payload.image != ''">
												相关的病情图片
											</div>
											<p v-if="item.payload.image != null && item.payload.image != ''">
												<van-image fit="cover" :src="item.payload.image[0]" />
											</p>
											<div v-if="item.payload.images != null && item.payload.images != ''">
												右眼眼睑+舌苔+舌下脉络图片
											</div>
											<p v-if="item.payload.images != null && item.payload.images != ''"
												class="askImgs">
												<van-image fit="cover" :src="item.payload.images[0]"
													@click="prevImg(item.payload.images)" />
												<span class="num">{{ item.payload.images.length }}图</span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div v-if="item.direction === 0 && item.messageType == 1" class="left-box">
								<div class="sendTime">{{ item.sendTime }}</div>
								<div class="left-info">
									<div class="avatar">
										<img :src="data.userImage" />
									</div>
									<div class="message-box">
										<div class="sendName">{{ item.sendName }}</div>
										<div class="message">
											<p>{{ item.text }}</p>
										</div>
									</div>
								</div>
							</div>
							<div v-if="item.direction === 0 && item.messageType == 2" class="left-box">
								<div class="sendTime">{{ item.sendTime }}</div>
								<div class="left-info">
									<div class="avatar">
										<img :src="data.userImage" />
									</div>
									<div class="message-box">
										<div class="sendName">{{ item.sendName }}</div>
										<div class="message">
											<p v-if="item.image != null && item.image != ''">
												<van-image fit="cover" :src="item.image"
													@click="prevImg([item.image])" />
											</p>
										</div>
									</div>
								</div>
							</div>
							<div v-if="item.direction === 0 && item.messageType == 9" class="left-box">
								<div class="sendTime">{{ item.sendTime }}</div>
								<div class="left-info">
									<div class="avatar">
										<img :src="data.userImage" />
									</div>
									<div class="message-box">
										<div class="sendName">{{ item.sendName }}</div>
										<div class="message">
											<div class="medical-record-item" v-for="(items, index) of item.payload.obj"
												:key="index">
												<div class="medical-record-item_lbx" v-if="items.modes == 'lbx'">
													{{ items.name }}
												</div>
												<span v-if="items.mode" class="medical-record-title">{{ items.id }}. {{
					items.name }}?
												</span>
												<span v-if="items.mode">{{
					items.audio ? "是" : "否"
				}}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div v-if="item.direction === 0 && item.messageType == 10" class="left-box">
								<div class="sendTime">{{ item.sendTime }}</div>
								<div class="left-info">
									<div class="avatar">
										<img :src="data.userImage" />
									</div>
									<div class="message-box">
										<div class="sendName">{{ item.sendName }}</div>
										<div class="message">
											<p class="xufang">申请续方</p>
											<p class="rp">Rp</p>
											<p>临床诊断：{{ item.payload.diagnose }}</p>
											<p v-for="(item1, index1) of item.payload.drug" :key="index1">
												{{ item1 }}
											</p>
										</div>
									</div>
								</div>
							</div>
							<div v-if="item.direction === 1 && item.messageType == 1" class="right-box">
								<div class="sendTime">{{ item.sendTime }}</div>
								<div class="left-info">
									<div class="message-box">
										<div class="sendName">{{ item.sendName }}</div>
										<div class="message">
											<p>{{ item.text }}</p>
										</div>
									</div>
									<div class="avatar">
										<img :src="data.doctorImage" />
									</div>
								</div>
							</div>
							<div v-if="item.direction === 1 && item.messageType == 3" class="right-box">
								<div class="sendTime">{{ item.sendTime }}</div>
								<div class="left-info">
									<div class="message-box">
										<div class="sendName">{{ item.sendName }}</div>
										<div class="message drug-box">
											<p class="rp">Rp</p>
											<p>临床诊断：{{ item.payload.diagnose }}</p>
											<p v-for="(item1, index1) of item.payload.drug" :key="index1">
												<span v-if="item1.role" class="recipe-drug-name">{{
					item1.role
				}}</span>
												                                        
												<span v-if="item1.quantity" class="drug-quantity">
													x {{ item1.quantity }}</span>
												<span v-if="!item1.role">{{ item1 }}</span>
											</p>
										</div>
									</div>
									<div class="avatar">
										<img :src="data.doctorImage" />
									</div>
								</div>
							</div>
							<div v-if="item.direction === 1 && item.messageType == 2" class="right-box">
								<div class="sendTime">{{ item.sendTime }}</div>
								<div class="left-info">
									<div class="message-box">
										<div class="sendName">{{ item.sendName }}</div>
										<div class="message">
											<p v-if="item.image != null && item.image != ''">
												<van-image fit="cover" :src="item.image"
													@click="prevImg([item.image])" />
											</p>
										</div>
									</div>
									<div class="avatar">
										<img :src="data.userImage" />
									</div>
								</div>
							</div>
							<div v-if="item.messageType == 4" class="sys-message">
								<span>{{ item.text }}</span>
							</div>
						</div>
					</van-pull-refresh>
				</div>
			</div>
		</van-overlay>

		<van-dialog v-model="end.show" title="是否结束就诊？" show-cancel-button confirm-button-text="结束问诊"
			@confirm="onEndConfirm" :before-close="onEndClose">
			<div class="end-dialog">
				<div class="desc">
					请输入就诊完成的原因，确认后将不会为该患者开具处方。
				</div>
				<div class="form">
					<van-field type="textarea" v-model="end.content" placeholder="请输入就诊完成原因" maxlength="200"
						show-word-limit />
					<div class="more">
						<van-popover v-model="end.more.show" trigger="click" placement="bottom-end" class="more-box"
							:offset="[20, 8]">
							<div class="end-dialog-more-list">
								<div class="item" v-for="(item, index) in end.options" :key="index">
									<div class="item-box" @click="onEndMoreSelect(item)">
										{{ item.text }}
									</div>
								</div>
							</div>
							<template #reference>
								<van-icon name="arrow-down" />
							</template>
						</van-popover>
					</div>
				</div>
			</div>
		</van-dialog>

		<AddressFill :deliver-type="data.deliverType" :defaults="data.userDeliveryAddress" :ask-no="data.askNo"
			:user-no="data.userNo" ref="addressFillRef" @success="onAddressSuccess" />

		<!-- 附加上传 -->
		<UploadAttach ref="UploadAttachRef" @success="onAttachUploaded" />
	</div>
</template>
<script>
import {
	getAskDetail,
	getPrescriptions,
	getThreeCauseReturn,
	getInterrogationChatRecord,
	setInquiryClose,
} from "../../api/index.js";
import { ImagePreview } from "vant";
import { mapGetters } from "vuex";
import { api as viewerApi } from "v-viewer";
import { offlineVisit, threeImagesImport } from "@/utils/index";
import { fileDownload } from '@/hooks/file'
import CoCopy from "@/components/common/copy.vue";
import Remarks from "@/components/remarks/index.vue";
import AddressFill from '@/components/address/fill.vue'
import UploadAttach from '@/components/upload/attach.vue'
import api from '@/utils/request'

export default {
	components: {
		CoCopy,
		Remarks,
		AddressFill,
		UploadAttach
	},
	data() {
		return {
			title: "问诊信息",
			askNo: "",
			data: {},
			questionAllList: [],
			showThreeCause: false,
			// 聊天记录
			serachData: {
				askNo: "",
				pageNo: 0,
				pageSize: 10,
			},
			chatList: [],
			showChat: false,
			count: 0,
			isLoading: false,
			end: {
				// 结束问诊
				show: false,
				content: "",
				options: [
					{
						text: "患者未回复信息，联系无应答",
						value: 1,
					},
					{
						text: "患者资料准备不全",
						value: 2,
					},
					{
						text: "患者主观不愿继续问诊",
						value: 3,
					},
					{
						text: "重复问诊",
						value: 4,
					},
					{
						text: "患者不能提供实名信息",
						value: 5,
					},
					{
						text: "已转企业微信问诊",
						value: 6,
					},
				],
				more: {
					show: false,
				},
			},
		};
	},
	computed: {
		...mapGetters(["getDiseaseTypeName"]),
		feedback() {
			let feedbackData = {
				info1: '',
				info2: '',
				info3: '',
			}
				; (this.data.userThreeConditionQuestionList || []).forEach(item => {
					feedbackData[`info${item.questionType + 1}`] += `${feedbackData[`info${item.questionType + 1}`] ? '、' : ''}${item.questionSubject}`

				})
			return feedbackData
		},
		attachFileNameComputed() {
			return this.data.treatmentAttach ? this.data.treatmentAttach.substring(this.data.treatmentAttach.lastIndexOf('/') + 1) : ''
		}
	},
	created() {
		this.askNo = this.$route.query.askNo;
		this.serachData.askNo = this.$route.query.askNo;
		// this.askNo = 'WZ2022032400008'
		// this.serachData.askNo = 'WZ2022032400008'
		this.getAskDetail();
	},
	methods: {
		offlineVisit,
		threeImagesImport,
		getAskDetail() {
			getAskDetail({ askNo: this.askNo }).then((res) => {
				if (res.code == 0) {
					this.data = res.data;
				}
			});
		},
		back() {
			this.$router.back();
		},
		prevImg1(index, arr) {
			ImagePreview({
				images: arr,
				startPosition: index,
				closeable: true,
			});
		},
		prevImg2(index, arr) {
			viewerApi({
				options: {
					toolbar: true,
					initialViewIndex: index || 0,
					zIndex: 9999,
					zoomRatio: 0.5,
					title: false,
				},
				images: arr,
			});
		},
		// 查看电子处方
		getPrescriptions() {
			if (this.data.isPrescription != 1) {
				this.$toast("暂无处方");
			} else {
				this.$router.push("/inquiryInfo/prescription?askNo=" + this.askNo);
			}
			// let data = {
			//     pageNo: 1,
			//     pageSize: 100,
			//     askNo: this.askNo
			// }
			// getPrescriptions(data).then(res => {
			//     if (res.code == 0) {
			//         if (res.data.list.length < 1 || !res.data.list.some((itm) => itm.url)) {
			//             this.$toast('暂无处方')
			//             return
			//         }
			//         let imgs = res.data.list.map(item => process.env.VUE_APP_IMG_HOST + item.url).reverse()
			//         // ImagePreview({
			//         //     images: imgs,
			//         //     closeable: true
			//         // })
			//         viewerApi({
			//             options: {
			//                 toolbar: true,
			//                 initialViewIndex: 0,
			//                 zIndex: 9999,
			//                 zoomRatio: 0.5,
			//                 title: false
			//             },
			//             images: imgs
			//         })
			//     }
			// })
		},
		// 查看三因反馈
		getThreeCauseReturn() {
			let data = {
				askNo: this.askNo,
			};
			this.questionAllList = [];
			getThreeCauseReturn(data).then((res) => {
				if (res.code == 0) {
					Object.keys(res.data).forEach((key) => {
						this.questionAllList.push(res.data[key]);
					});
					this.showThreeCause = true;
				}
			});
		},
		// 查看聊天记录
		getInterrogationChatRecord(flag) {
			if (flag) {
				this.serachData.pageNo = 0;
				this.chatList = [];
			}
			this.serachData.pageNo++;
			getInterrogationChatRecord(this.serachData)
				.then((res) => {
					if (res.code == 0) {
						this.isLoading = false;
						if (res.data.list.length < 1 && this.serachData.pageNo == 1) {
							this.$toast("暂无聊天记录");
							return;
						}
						res.data.list.filter((item) => {
							if (
								item.payload != "" &&
								item.payload != null &&
								item.payload != undefined &&
								typeof item.payload == "string"
							) {
								item.payload = JSON.parse(item.payload);
							}
						});
						this.chatList = res.data.list.concat(this.chatList);
						this.showChat = true;
					} else {
						this.isLoading = false;
						this.serachData.pageNo--;
					}
				})
				.catch((err) => {
					this.isLoading = false;
					this.serachData.pageNo--;
				});
		},
		// 下拉刷新
		onRefresh() {
			this.getInterrogationChatRecord();
		},
		prevImg(imgArr) {
			ImagePreview({
				images: imgArr,
				closeable: true,
			});
		},
		// onInquiryClose() { // 问诊结束
		//     this.$dialog.confirm({
		//         title: '是否确认替患者主动结束当前问诊？',
		//         message: ''
		//     }).then(() => {
		//         setInquiryClose({ askNo: this.askNo }).then(() => {
		//             this.$toast.success('操作成功');
		//             this.getAskDetail()
		//         })
		//     }).catch(() => {

		//     });
		// },
		onInquiryClose() {
			this.end.content = "";
			this.end.show = true;
		},
		onEndConfirm() {
			if (!this.end.content.trim()) {
				this.$toast.fail("请输入就诊完成原因");
				return false;
			}
			setInquiryClose(this.askNo, { reason: this.end.content.trim() }).then(
				() => {
					this.$toast.success("操作成功");
					this.end.show = false;
					this.end.more.show = false;
					this.getAskDetail();
				}
			);
		},
		onEndClose(action, done) {
			if (action == "cancel") {
				done();
			} else {
				done(false);
			}
		},
		onEndMoreSelect(row) {
			this.end.content = row.text;
			this.end.more.show = false;
		},
		onAddressEditShow() {
			this.$refs.addressFillRef && this.$refs.addressFillRef.onAddressGet().then(() => {
				this.$refs.addressFillRef.onAddressShow();
			});
		},
		onAddressSuccess() { // 设为自提或
			this.getAskDetail();
		},
		// 附件上传回调
		async onAttachUploaded(treatmentAttach) {
			await api({
				method: 'put',
				url: '/user-service/app/askinfo/modifyAsk',
				data: {
					askNo: this.askNo,
					treatmentAttach
				}
			})
			this.getAskDetail();
		},
		// 附件下载
		async onAttachFileDownload(url) {
			try {
				await this.$dialog.confirm({
                    title: '是否确认下载?',
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    closeOnClickOverlay: false
                })
				fileDownload(url, this.attachFileNameComputed, true)
			} catch (error) {}
		}
	}
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/base";

.container {
	padding: 10px 10px 100px;

	.mian {
		// height: calc(100vh - #{100px});
		background: #fff;
		border-radius: 4px;
		padding: 0 20px;
		overflow-y: auto;

		.header {
			border-bottom: 1px solid #eee;
		}

		.content {
			padding-top: 12px;
			border-bottom: 1px solid #eee;

			.row {
				margin-bottom: 18px;

				.row-label {
					font-size: 16px;
					color: #999;
					margin-bottom: 6px;

					.label-box {
						display: flex;
						align-items: center;
						justify-content: space-between;
						border-bottom: 1px solid #e5e5e5;
						padding-bottom: 10px;
						margin-bottom: 10px;
					}

					&-box {
						display: flex;
						align-items: center;
						justify-content: space-between;

						.edit {
							color: #333;
							display: flex;
							align-items: center;
							font-size: 14px;
							cursor: pointer;
							@include unselected();

							.van-icon {
								font-size: 16px;
							}
						}
					}
				}

				.row-item {
					display: flex;
					font-size: 16px;
					color: #333333;
					align-items: flex-start;

					&+.row-item {
						margin-top: 4px;
					}

					.item-lable {
						padding-right: 3px;
					}

					.item-info {
						flex: 1;
					}
				}

				.row-value {
					font-size: 16px;
					color: #333;
					word-break: break-all;

					.flex {
						display: flex;

						.img {
							width: 90px;
							height: 90px;
							margin-right: 6px;
							margin-bottom: 2px;
							background: #f7f8fa;
							border-radius: 8px;
							display: flex;
							align-items: center;
							justify-content: center;
							white-space: nowrap;
							font-size: 12px;
						}
					}

					:deep() .van-image__img {
						width: 90px;
						height: 90px;
						border-radius: 8px;
						cursor: pointer;
					}

					.remarks-list {
						.item {
							display: flex;
							justify-content: space-between;

							&-box {
								position: relative;
								padding-left: 30px;

								&::before {
									content: "";
									width: 10px;
									height: 10px;
									background: #e5e5e5;
									position: absolute;
									left: 0;
									top: 0;
									border-radius: 10px;
								}

								&::after {
									content: "";
									position: absolute;
									left: 5px;
									top: 0;
									bottom: 0;
									width: 1px;
									background: #e5e5e5;
								}

								.item-head {
									display: flex;
									justify-content: space-between;
									align-items: center;

									.name {
										margin-left: 15px;
									}
								}

								.item-body {
									margin-top: 10px;
								}
							}

							&-btn {
								flex: none;
								margin-left: 20px;
								display: flex;

								.link {
									position: relative;
									margin-left: 15px;

									&:nth-child(2) {
										color: #f00;
									}

									&:nth-child(3) {
										color: #efa943;
									}
								}
							}
						}
					}

					.p {
						&:not(:first-child) {
							margin-top: 8px;
						}

						&:first-child {
							padding-top: 4px;
						}

						&-label {
							font-weight: bold;
						}
					}
				}
			}
		}

		.footer {
			padding: 20px 0;

			&-top,
			&-bottom {
				display: flex;
				justify-content: flex-end;
			}

			&-bottom {
				margin-top: 10px;
			}

			.van-button {
				margin-left: 10px;
			}
		}
	}

	.wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
	}

	.block {
		width: 322px;
		min-height: 60vh;
		max-height: 80vh;
		overflow-y: scroll;
		-webkit-overflow-scrolling: touch;
		background-color: #fff;
		border-radius: 8px;

		.item {
			padding-bottom: 20px;
			padding: 0 40px 20px 40px;
			font-size: 14px;

			.header {
				padding: 20px 0;
				text-align: center;
				color: #333;
				font-weight: bold;
				font-size: 16px;
			}

			.row {
				display: flex;
				justify-content: space-between;
				margin-bottom: 10px;

				span {
					color: #999;

					&:last-child {
						color: #e0b747;
					}
				}

				.questionRadio {
					color: #28307c !important;
				}
			}
		}
	}

	// 聊天记录
	.chat {
		width: 360px;
		height: 80vh;
		background: #fff;
		border-radius: 8px;
		padding: 20px;
		overflow-y: scroll;

		// :deep() .van-pull-refresh {
		//     height: auto;
		//     overflow-y: scroll;
		// }
		.content {
			font-size: 14px;
			overflow-y: scroll;

			.left-box,
			.right-box {
				.sendTime {
					text-align: center;
					font-size: 14px;
					color: #919191;
					padding: 10px 0;
				}

				.left-info {
					display: flex;

					.avatar {
						width: 50px;
						height: 50px;
						margin-right: 10px;

						img {
							width: 50px;
							height: 50px;
							border-radius: 50%;
						}
					}

					.message-box {
						.sendName {
							color: #919191;
							margin-bottom: 10px;
						}

						.message {
							display: flex;
							flex-direction: column;
							word-break: break-all;
							background: #f7f7f7;
							padding: 10px 20px;
							max-width: 70%;
							border-radius: 8px;

							p {
								margin: 0;
								width: 100%;
								padding: 6px 0;
							}

							.medical-record-item_lbx {
								text-align: center;
								color: #28307c;
								padding: 20px 0 10px 0;
							}

							.xufang {
								height: 30px;
								line-height: 30px;
								border-bottom: 1px solid #e6e6e6;
								color: #1a1a1a;
							}

							.rp {
								font-size: 24px;
								color: #333333;
							}

							.askImgs {
								position: relative;

								.num {
									position: absolute;
									top: 6px;
									right: 0;
									background: rgba(0, 0, 0, 0.5);
									border-radius: 2px;
									padding: 4px 10px;
									color: #fff;
									font-size: 12px;
								}
							}
						}

						.drug-box {
							background: #fff !important;
							box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.2);
						}
					}
				}
			}

			.right-box {
				.message-box {
					.sendName {
						text-align: right;
					}

					.message {
						float: right;
						background: #e7f3fd !important;
					}
				}

				.left-info {
					justify-content: flex-end;

					.recipe-drug-name {
						width: 80%;
					}

					.avatar {
						margin-right: 0;
						margin-left: 10px;
					}
				}
			}

			.sys-message {
				padding: 10px 0;
				text-align: center;

				span {
					font-size: 12px;
					color: #919191;
					border-radius: 4px;
					padding: 10px;
					background: #f7f7f7;
					display: inline-block;
				}
			}
		}
	}

	.row-address {
		display: flex;
		align-items: flex-start;

		.txt {
			word-break: break-all;
			margin-right: 20px;
		}

		.co-copy {
			flex: none;
		}

		.none {
			margin-top: 5px;
		}
	}

	.buttons {
		background: #fff;
		margin-top: 10px;
		padding: 20px 0;
		border-radius: 4px;

		&-box {
			display: flex;
			flex-wrap: wrap;
			gap: 15px;

			.item {
				width: calc(25% - 15px);
				display: flex;
				align-items: center;
				justify-content: center;

				.icon {
					width: 36px;
					height: 36px;
					border-radius: 50px;
					margin: 0 auto;
					display: flex;
					align-items: center;
					justify-content: center;

					.icon-box {
						width: 24px;
						height: 24px;
						background-repeat: no-repeat;
						background-size: 100% 100%;
						background-position: center center;
					}

					.van-icon {
						font-size: 24px;
					}

					&.three {
						background: #ecfbf3;

						.icon-box {
							background-image: url(@/assets/images/inquiry/three.png);
						}
					}

					&.prescription {
						background: #fdf8ed;

						.icon-box {
							background-image: url(@/assets/images/inquiry/prescription.png);
						}
					}

					&.edit {
						background: #feeff2;

						.icon-box {
							background-image: url(@/assets/images/inquiry/edit.png);
						}
					}

					&.logistics {
						background: #eeeffe;

						.icon-box {
							background-image: url(@/assets/images/inquiry/logistics.png);
						}
					}

					&.record {
						background: #f5eefe;

						.icon-box {
							background-image: url(@/assets/images/inquiry/record.png);
						}
					}

					&.evaluate {
						background: #d6ffd8;
					}

					&.message {
						background: #f5eefe;

						svg {
							width: 20px;
							height: 20px;
						}
					}
				}

				.name {
					font-size: 14px;
					margin-top: 7px;
					color: #666;
					transform: scale(0.92);
				}

				&.dis {
					opacity: 0.7;
				}
			}
		}

		&-close {
			padding: 20px 20px 0;

			.van-button {
				width: 100%;
				height: 42px;
			}
		}
	}

	.main-header {
		position: relative;

		.van-button {
			position: absolute;
			right: 0;
			top: 6px;
			height: 30px;
			border-radius: 4px;
			font-size: 12px;

			&.van-button--disabled {
				background: #c5c3c4 !important;
				border-color: #c5c3c4 !important;
				opacity: 1 !important;
			}
		}
	}

	.end-dialog {
		padding: 0 20px;

		.desc {
			margin-top: 10px;
			font-size: 16px;
		}

		.form {
			position: relative;
			border: 1px solid #e5e5e5;
			border-radius: 4px;
			overflow: hidden;
			margin-top: 15px;

			.more {
				position: absolute;
				right: 10px;
				top: 10px;
			}
		}
	}
}

.attach {
	@include flex(center, space-between);
	padding-bottom: 20px;

	.label {
		word-break: break-all;
		display: flex;
		.name {
			flex: none;
			font-weight: bold;
			font-size: 16px;
		}
		.file {
			color: #4187f7;
			cursor: pointer;
			&:hover {
				opacity: 0.7;
			}
		}
	}
	.value {
		flex: none;
		margin-left: 30px;
	}

	.van-button {
		color: #5290f8 !important;
		height: 30px;
	}
}
</style>

<style lang="scss">
.end-dialog-more-list {
	padding: 10px;

	.item {
		&-box {
			padding: 10px;
			cursor: pointer;

			&:active {
				background: #f4f4f4;
			}
		}
	}
}
</style>